import * as React from 'react'

export const useAiResponseStream = () => {
  const [aiResponse, setAiResponse] = React.useState('')
  const [aiStreamComplete, setAiStreamComplete] = React.useState(false)

  React.useEffect(() => {
    const eventURL = `/orientation/program_overview/create_ai_sse?format=json`
    const eventSource = new EventSource(eventURL)

    eventSource.addEventListener('message', (event) => {
      if (event.data != 'null') {
        setAiResponse((r) => `${r}${event.data}`)
      }
    })

    eventSource.addEventListener('error', (event) => {
      if (event.eventPhase === EventSource.CLOSED) {
        eventSource.close()
      }
    })

    return () => {
      eventSource.close()
    }
  }, [])

  return {
    aiResponse,
    setAiResponse,
    aiStreamComplete,
    setAiStreamComplete,
  }
}
